import { cva } from '@/styled-system/css';

export const checkboxRecipe = cva({
  base: {
    display: 'inline-block',
    width: 'Checkbox.box',
    height: 'Checkbox.box',
    borderWidth: 'Checkbox.box',
    borderStyle: 'solid',
    borderRadius: 'Checkbox.box',
    backgroundPosition: 'center',
    backgroundSize: '{sizes.Checkbox.icon}',
    backgroundRepeat: 'no-repeat',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    indeterminate: {
      true: {
        backgroundColor: 'Checkbox.bg.indeterminate',
        borderColor: 'Checkbox.border.indeterminate',
        backgroundImage: {
          base: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M26%2018H6a2%202%200%200%201%200-4h20a2%202%200%200%201%200%204z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E")`,
          _dark: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M26%2018H6a2%202%200%200%201%200-4h20a2%202%200%200%201%200%204z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")`,
        },
      },
      false: {
        '&:checked': {
          backgroundColor: 'Checkbox.bg.selected',
          borderColor: 'Checkbox.border.selected',
          backgroundImage: {
            base: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E")`,
            _dark: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")`,
          },
        },
        '&:not(:checked)': {
          backgroundColor: 'Checkbox.bg.default',
          borderColor: 'Checkbox.border.default',
        },
      },
    },
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {
        'focusOutline': true,
        '_hover': {
          cursor: 'pointer',
        },
        '&:checked': {
          _hover: {
            borderColor: 'Checkbox.border.selectedHover',
            backgroundColor: 'Checkbox.bg.selectedHover',
          },
          _active: {
            borderColor: 'Checkbox.border.selectedPressed',
            backgroundColor: 'Checkbox.bg.selectedPressed',
          },
        },
        '&:not(:checked)': {
          _hover: {
            backgroundColor: 'Checkbox.bg.hover',
            borderColor: 'Checkbox.border.hover',
          },
          _active: {
            backgroundColor: 'Checkbox.bg.pressed',
            borderColor: 'Checkbox.border.pressed',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      disabled: false,
      indeterminate: true,
      css: {
        '&:checked,&:not(:checked)': {
          _hover: {
            backgroundColor: 'Checkbox.bg.indeterminateHover',
            borderColor: 'Checkbox.border.indeterminateHover',
          },
          _active: {
            backgroundColor: 'Checkbox.bg.indeterminatePressed',
            borderColor: 'Checkbox.border.indeterminatePressed',
          },
        },
      },
    },
  ],
});
